import type { ApiClient } from "./api-client";
import { createTransport, type HttpApiClientOptions } from "./http/transport";
import { createAnalyticsApi } from "./domains/analytics";
import { createAuthApi } from "./domains/auth";
import { createInboxApi } from "./domains/inbox";
import { createContactsApi } from "./domains/contacts";
import { createChannelsApi } from "./domains/channels";
import { createBroadcastsApi } from "./domains/broadcasts";
import { createTemplatesApi } from "./domains/templates";
import { createFlowsApi } from "./domains/flows";
import { createAiKnowledgeApi } from "./domains/ai-knowledge";
import { createCatalogApi } from "./domains/catalog";
import { createTravelApi } from "./domains/travel";
import { createProspectorApi } from "./domains/prospector";
import { createAccountsApi } from "./domains/accounts";
import { createSellApi } from "./domains/sell";
import { createBookingsApi } from "./domains/bookings";
import { createTeamApi } from "./domains/team";
import { createBillingApi } from "./domains/billing";
import { createWorkspaceApi } from "./domains/workspace";
import { createIntegrationsApi } from "./domains/integrations";

export { ApiError, isApiError } from "./errors";
export type { ApiClient } from "./api-client";
export type { HttpApiClientOptions } from "./http/transport";
export { SHELL_GET_CACHE_TTL_MS } from "./http/transport";
export { toSitemapUrl } from "./sitemap-url";
export * from "./client-types";

/**
 * `fetch`-based client. Authentication is the HttpOnly `wato_dash_sid` cookie
 * (`credentials: "include"`); the dashboard never stores tokens. The browser adds `Origin`
 * to state-changing requests, which the API checks (CSRF defence in depth).
 * Methods live in `./domains/*`; the request pipeline in `./http/transport`.
 */
export function createHttpApiClient(options: HttpApiClientOptions): ApiClient {
  const transport = createTransport(options);
  return {
    ...createAnalyticsApi(transport),
    ...createAuthApi(transport),
    ...createInboxApi(transport),
    ...createContactsApi(transport),
    ...createChannelsApi(transport),
    ...createBroadcastsApi(transport),
    ...createTemplatesApi(transport),
    ...createFlowsApi(transport),
    ...createAiKnowledgeApi(transport),
    ...createCatalogApi(transport),
    ...createTravelApi(transport),
    ...createProspectorApi(transport),
    ...createAccountsApi(transport),
    ...createSellApi(transport),
    ...createBookingsApi(transport),
    ...createTeamApi(transport),
    ...createBillingApi(transport),
    ...createWorkspaceApi(transport),
    ...createIntegrationsApi(transport),
  };
}
